export const PUBLIC_URL: string = process.env.REACT_APP_PUBLIC_URL || '';
export const KEY_SECRET: string = process.env.REACT_APP_KEY_SECRET || "";


export const AWS_S3_BUCKET_URL = process.env.REACT_APP_AWS_BUCKET_URL;

